import { Api } from 'helpers/ApiClient';

export class Details {
  static async show() {
    try {
      const response = await Api.client.get('/api/v1/user.json');
      return {
        user: response.data.user,
        status: response.status,
      };
    } catch (e) {
      console.error('details request error: ', e.message);
      return {
        error: e.response.message,
        textError: e.response.data,
      };
    }
  }
  static async updateEmail(body) {
    try {
      const response = await Api.client.put(
        '/api/v1/account/update_email',
        body,
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (e) {
      console.error('signOut request error: ', e.message);
      return {
        error: 'This email has already existed! Try another one!',
        textError: e.response.data,
      };
    }
  }

  static async updatePassword(body) {
    try {
      const response = await Api.client.put(
        '/api/v1/account/update_password',
        body,
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (e) {
      console.error('signOut request error: ', e.message);
      return {
        error: 'Unknown error updateEmail',
        textError: e.response.data,
      };
    }
  }

  static async updateReceives(body) {
    try {
      const response = await Api.client.put(
        '/api/v1/account/update_mailing_status',
        body,
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (e) {
      console.error('updateReceives request error: ', e.message);
      return {
        error: 'Unknown error updateReceives',
        textError: e.response.data,
      };
    }
  }

  static async confirmEmail() {
    try {
      const response = await Api.client.get(
        '/api/v1/user/send_email_confirmation.json',
      );
      return {
        user: response.data,
        status: response.status,
      };
    } catch (e) {
      console.error('details request error: ', e.message);
      return {
        error: e.response.message,
        textError: e.response.data,
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/profileDetails/api.js